































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore, { PessoaOperadora, ClassificacaoOperadora } from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalRegraDeCalculoIncluirLocaisExecucao extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingAddRegraCalculoOperadora() { return this.loadAddRegraCalculoOperadora }
  set loadingAddRegraCalculoOperadora(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModal() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoOperadora }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoOperadora', value }) }

  get localExecucaoSelected() { return this.getRegrasDeCalculoStore.localExecucaoSelected }
  set localExecucaoSelected(value: any) { this.getRegrasDeCalculoStore.setLocalExecucaoSelected(value) }

  async addRegra() {
    this.loadingAddRegraCalculoOperadora = true
    const request = await this.getRegrasDeCalculoStore.addRegraLocalExecucao()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculoOperadora = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Operadora incluída com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculoOperadora = false
    this.showModal = false
  }

  @Watch('showModal')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (value) {
      this.getRegrasDeCalculoStore.getLocaisExecucaoList()
    }

    if (!value) {
      // 
    }
  }
}
